import { CustomerKycDisplayStatus, CustomerKycStatus, CustomerSettings } from '../@types';
import { KYC_VERIFICATION_TRIGGER, PAYMENT_TRANSACTION_TYPE, PaymentTransactionType } from '../types/enums';

type CustomerKycState = Pick<CustomerSettings, 'kycStatus'>;
type MarketplaceKycState = {
  enabled?: boolean;
  required?: boolean;
  trigger?: CustomerSettings['kycTrigger'];
};

export const KYC_RETURN_PENDING_STORAGE_KEY = 'complycube:return-pending';

export const getCustomerKycDisplayStatus = (status?: CustomerKycStatus | null): CustomerKycDisplayStatus => {
  if (status === 'rejected' || status === 'support') {
    return 'failed';
  }

  return status ?? 'notVerified';
};

export const isCustomerVerified = (status?: CustomerKycStatus | null): boolean => status === 'verified';

export const isKycRequiredByMarketplace = (kycState?: MarketplaceKycState): boolean =>
  Boolean(kycState?.required ?? kycState?.enabled);

export const requiresKycVerification = (
  customerKycState?: CustomerKycState,
  marketplaceKycState?: MarketplaceKycState
): boolean => isKycRequiredByMarketplace(marketplaceKycState) && !isCustomerVerified(customerKycState?.kycStatus);

export const shouldShowRegistrationKyc = (
  customerKycState?: CustomerKycState,
  marketplaceKycState?: MarketplaceKycState
): boolean =>
  requiresKycVerification(customerKycState, marketplaceKycState) &&
  marketplaceKycState?.trigger === KYC_VERIFICATION_TRIGGER.REGISTRATION;

export const shouldShowTransactionKyc = (
  customerKycState: CustomerKycState | undefined,
  marketplaceKycState: MarketplaceKycState | undefined,
  transactionType: PaymentTransactionType
): boolean => {
  if (!requiresKycVerification(customerKycState, marketplaceKycState)) {
    return false;
  }

  if (transactionType === PAYMENT_TRANSACTION_TYPE.DEPOSIT) {
    return marketplaceKycState?.trigger === KYC_VERIFICATION_TRIGGER.FIRST_DEPOSIT;
  }

  if (transactionType === PAYMENT_TRANSACTION_TYPE.WITHDRAW) {
    return marketplaceKycState?.trigger === KYC_VERIFICATION_TRIGGER.FIRST_WITHDRAWAL;
  }

  return false;
};
